import styled from 'styled-components';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FormRow = styled.div`
  width: 50%;
`;

const Table = styled.table`
  text-align: left;
  margin: 1em;
  tbody {
    tr {
      height: 2em;
      &:nth-child(odd) {
        background: #efefef;
      }
    }
  }
`;

const EditHeader = styled.th`
  width: 10%;
`;

const NewRecordLink = styled.div`
  width: 100%;
  margin: 1em;
`;

export { FormWrapper, FormRow, Table, EditHeader, NewRecordLink };
